
import {Component, ChangeDetectionStrategy, input} from '@angular/core';

@Component({
    selector: 'allergens-indicator',
    template: `
    <div class="w-full h-full">
      <div
        class="text-center tooltip absolute left-0 rounded p-1 text-sm -translate-y-1/4 w-48 text-white font-semibold transition"
        [class.bg-orange-1]="!isAllergenPresent()"
        [class.bg-red-500]="isAllergenPresent()">
        @if (!isAllergenPresent()) {
          <span>Un ou plusieurs allergènes sont présents</span>
        }
        @if (isAllergenPresent()) {
          <span>Un allergène auquel vous êtes allergique est présent !</span>
        }
      </div>
      <svg class="allergens-svg"
        [class.red]="this.isAllergenPresent()"
        [style.color]="forceColor() !== '' ? forceColor() : null"
        [style.fill]="forceColor() !== '' ? forceColor() : null"
    
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
        <defs>
          <clipPath id="clip-path">
            <path id="Clip_2" data-name="Clip 2" d="M0,0H21V20H0Z" fill="none"></path>
          </clipPath>
          <clipPath id="clip-path-2">
            <path id="Clip_2-2" data-name="Clip 2" d="M0,0H20V20H0Z" fill="none"></path>
          </clipPath>
        </defs>
        <g id="Group_3" data-name="Group 3">
          <path id="Clip_2-3" data-name="Clip 2" d="M0,0H21V20H0Z" fill="none"></path>
        </g>
        <g id="Group_3-3" data-name="Group 3">
          <path id="Clip_2-4" data-name="Clip 2" d="M0,0H20V20H0Z" fill="none"></path>
          <g id="Group_3-4" data-name="Group 3" clip-path="url(#clip-path-2)">
            <path id="Fill_1" data-name="Fill 1"
            d="M10,20A9.995,9.995,0,0,1,2.934,2.931,9.99,9.99,0,1,1,10,20ZM7.132,13.612h5.755l.7,1.5h3.2L10,1.6,3.211,15.107H6.435l.7-1.5Zm4.828-2.273h-3.9L10,6.856l1.961,4.482Z"></path>
          </g>
        </g>
      </svg>
    </div>`,
    styleUrls: ["./AllergensIndicator.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class AllergensIndicatorComponent {

  readonly isAllergenPresent = input.required<boolean>();

  readonly forceColor = input<string>("");

  constructor() {
  }
}
